import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import { linkStep, navigationStep } from "../../../redux/slices/navigation";
import {
  PlayMarketAppstoreApi,
  PlayMarketAppstoreEdit,
  GetQrLink,
} from "../../../redux/requests/store";
import { validLinkPattern } from "../../../RegExpValidations";
import { preloaderToggle } from "../../../redux/slices/preloader";
import { saveStoreAppleGoogle } from "../../../redux/slices/saveValue";
import StepCustomize from "../../../components/stepCustomize";
import QrTitleField from "../../../components/input/qrTitleField";
import axios from "axios";
import { handleLink, isNoEditRoute } from "../../../hooks/helpers";
import Form from "react-bootstrap/Form";
import InputText from "../../../components/input/inputText";
import { SelectCategory } from "../../../components";
import { MAX_LINK_LENGTH } from "../../../constants/inputValues";
import useTypeDecription from "../../../hooks/useTypeDecription";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

export default function PlayMarketAppstore() {
  const {
    lang,
    getQrLinkSliceId,
    categoryChange,
    errorMsg,
    error,
    force,
    valueStoreAppleGoogle,
  } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo,
    getQrLinkSliceId: state.getQrLinkSlice.id,
    categoryChange: state.categories.categoryChange,
    error: state.getQrLinkSlice.error,
    errorMsg: state.changeLang.language.stepTwo.errors,
    force: state.forceСreate.force,
    valueStoreAppleGoogle: state.saveValue.valueStoreAppleGoogle,
  }));
  const { id } = useParams();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();

  const [qrTitle, setQrTitle] = useState("");
  const [appStore, setAppStore] = useState("");
  const [googlePlay, setGooglePlay] = useState("");
  const [otherDevise, setOtherDevise] = useState("");
  const [appStoreValidation, setAppStoreValidation] = useState(false);
  const [googlePlayValidation, setGooglePlayValidation] = useState(false);
  const [otherDeviseValidation, setOtherDeviseValidation] = useState(false);
  const [empty, setEmpty] = useState(false);

  useEffect(() => {
    getContent("store");
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/entry/store/get/${id}`)
        .then(({ data }) => {
          const values = [
            !!data[0]?.iosLink ? data[0].iosLink : "",
            !!data[0]?.androidLink ? data[0].androidLink : "",
            !!data[0]?.additionalLink ? data[0].additionalLink : "",
            !!data.qrTitle ? data.qrTitle : "",
            !!data.adsCategories ? data.adsCategories : "",
          ];
          dispatch(saveStoreAppleGoogle(values));
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  function reset() {
    dispatch(
      GetQrLink(() =>
        PlayMarketAppstoreEdit([
          getQrLinkSliceId || id,
          appStore,
          googlePlay,
          otherDevise,
          categoryChange,
          qrTitle,
        ])
      )
    ).then(() => {
      if (!isNoEditRoute) {
        window.location.href = adminEntryLocation;
      }
    });
    dispatch(
      saveStoreAppleGoogle([
        appStore,
        googlePlay,
        otherDevise,
        qrTitle,
        categoryChange,
        force,
      ])
    );
    dispatch(preloaderToggle(true));
    if (isNoEditRoute) {
      dispatch(navigationStep(3));
      navigate("/qr");
    }
  }
  function step() {
    if (
      (!!appStore && appStoreValidation) ||
      (!!googlePlay && googlePlayValidation) ||
      (!!otherDevise && otherDeviseValidation)
    ) {
      if (!getQrLinkSliceId && !id) {
        setEmpty(false);
        dispatch(
          GetQrLink(() =>
            PlayMarketAppstoreApi([
              appStore,
              googlePlay,
              otherDevise,
              categoryChange,
              force,
              qrTitle,
            ])
          )
        );
        dispatch(preloaderToggle(true));
        dispatch(
          saveStoreAppleGoogle([
            appStore,
            googlePlay,
            otherDevise,
            qrTitle,
            categoryChange,
            force,
          ])
        );
        dispatch(navigationStep(3));
        navigate("/qr");
      }
    } else {
      setEmpty(true);
    }

    if (!!getQrLinkSliceId || id) {
      return reset();
    }
  }

  useEffect(() => {
    if (
      (appStore !== "" && appStoreValidation) ||
      (googlePlay !== "" && googlePlayValidation) ||
      (otherDevise !== "" && otherDeviseValidation)
    ) {
      dispatch(linkStep(true));
    } else {
      dispatch(linkStep(false));
    }
  }, [appStore, googlePlay, otherDevise]);

  useEffect(() => {
    setAppStoreValidation(validLinkPattern.test(valueStoreAppleGoogle[0]));
    setGooglePlayValidation(validLinkPattern.test(valueStoreAppleGoogle[1]));
    setOtherDeviseValidation(validLinkPattern.test(valueStoreAppleGoogle[2]));
    setAppStore(valueStoreAppleGoogle[0]);
    setGooglePlay(valueStoreAppleGoogle[1]);
    setOtherDevise(valueStoreAppleGoogle[2]);
    setQrTitle(valueStoreAppleGoogle[3]);
  }, [valueStoreAppleGoogle]);

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <InputText
            error={
              !!error ||
              (!appStoreValidation && appStore.length > 5) ||
              appStore.length > MAX_LINK_LENGTH
            }
            valid={
              appStoreValidation &&
              appStore.length > 5 &&
              appStore.length <= MAX_LINK_LENGTH
            }
            type="link"
            placeholder={lang.store[0]}
            name="appStore"
            value={appStore}
            onChange={(e) =>
              handleLink(e.target.value, setAppStoreValidation, setAppStore)
            }
            popoverText={lang.store[24]}
          >
            {!appStoreValidation && appStore.length > 5 && (
              <Form.Text className="text-danger">
                {lang.link[2]}: https://me-qr.com/
              </Form.Text>
            )}
            {appStore.length > MAX_LINK_LENGTH && (
              <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
            )}
          </InputText>

          <InputText
            error={
              !!error ||
              (!googlePlayValidation && googlePlay.length > 5) ||
              googlePlay.length > MAX_LINK_LENGTH
            }
            valid={
              googlePlayValidation &&
              googlePlay.length > 5 &&
              googlePlay.length <= MAX_LINK_LENGTH
            }
            type="link"
            placeholder={lang.store[2]}
            name="googlePlay"
            value={googlePlay}
            onChange={(e) =>
              handleLink(e.target.value, setGooglePlayValidation, setGooglePlay)
            }
            popoverText={lang.store[25]}
          >
            {!googlePlayValidation && googlePlay.length > 5 && (
              <Form.Text className="text-danger">
                {lang.link[2]}: https://me-qr.com/
              </Form.Text>
            )}
            {googlePlay.length > MAX_LINK_LENGTH && (
              <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
            )}
          </InputText>

          <InputText
            error={
              !!error ||
              (!otherDeviseValidation && otherDevise.length > 5) ||
              otherDevise.length > MAX_LINK_LENGTH
            }
            valid={
              otherDeviseValidation &&
              otherDevise.length > 5 &&
              otherDevise.length <= MAX_LINK_LENGTH
            }
            type="link"
            placeholder={lang.store[4]}
            name="otherDevice"
            value={otherDevise}
            onChange={(e) =>
              handleLink(
                e.target.value,
                setOtherDeviseValidation,
                setOtherDevise
              )
            }
            popoverText={lang.store[26]}
          >
            {!otherDeviseValidation && otherDevise.length > 5 && (
              <Form.Text className="text-danger">
                {lang.link[2]}: https://me-qr.com/
              </Form.Text>
            )}
            {otherDevise.length > MAX_LINK_LENGTH && (
              <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
            )}
          </InputText>

          {empty && (
            <Form.Text className="text-danger">{lang.store[6]}</Form.Text>
          )}
          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>

        <SelectCategory />

        <StepCustomize
          emulate={step}
          disabled={
            (!appStoreValidation &&
              !googlePlayValidation &&
              !otherDeviseValidation) ||
            appStore.length > MAX_LINK_LENGTH ||
            googlePlay.length > MAX_LINK_LENGTH ||
            otherDevise.length > MAX_LINK_LENGTH
          }
        />
      </SecondScreen>

      {isNoEditRoute && content}
    </>
  );
}
